import { MINIMAX_TYPES } from '@/constants';
import get from 'get-object-path';

export const importedFileEdit = {
    namespaced: true,

    state: {
        initialFile: null,
        pieces: [],
        selectedPiece: null,
        selectedTypes: [MINIMAX_TYPES[0], MINIMAX_TYPES[1], MINIMAX_TYPES[2]],
        infoModalFile: null,
        infoModalTelemetryFile: null
    },

    getters: {
        firstPositionTimestamp(state) {
            return get(state, 'initialFile.session_info.start_time');
        },

        initialFile(state) {
            return state.initialFile;
        },

        pieces(state) {
            return state.pieces;
        },

        selectedPiece(state) {
            return state.selectedPiece;
        },

        selectedTypes(state) {
            return state.selectedTypes;
        },

        selectedInfoFile(state) {
            return state.infoModalFile;
        },

        selectedInfoTelemetryFile(state) {
            console.log('selectedInfoTelemetryFile', state.infoModalTelemetryFile);
            return state.infoModalTelemetryFile;
        }
    },

    mutations: {
        resetState(state) {
            state.pieces = [];
            state.selectedPiece = null;
        },

        resetInitialFile(state) {
            state.initialFile = null;
        },

        setInitialFile(state, file) {
            if (!state.initialFile) {
                state.initialFile = file;
            }
        },

        selectPiece(state, piece) {
            state.selectedPiece = piece;
        },

        setPieces(state, pieces) {
            state.pieces = pieces;
        },

        insertCustomPiece(state, { afterIndex, type }) {
            const newPiece = {
                id: `custom_${Date.now()}`,
                custom: true,
                pieceType: type || 'distance',
                planned_distance: 0,
                planned_time: 0,
                start: 0,
                end: 0,
                value: null,
                rate: null,
                processBy: 'gps',
                save_start_sequence: false,
                rolling_start: false
            };
            state.pieces.splice(afterIndex + 1, 0, newPiece);
        },

        removeCustomPiece(state, { id }) {
            const index = state.pieces.findIndex(p => p.id === id);
            if (index !== -1) {
                state.pieces.splice(index, 1);
                if (state.selectedPiece && state.selectedPiece.id === id) {
                    state.selectedPiece = null;
                }
            }
        },

        setSelectedTypes(state, selectedTypes) {
            state.selectedTypes = selectedTypes;
        },

        setInfoModalFile(state, file) {
            state.infoModalFile = file;
        },

        setInfoModalTelemetryFile(state, telemetryFile) {
            state.infoModalTelemetryFile = telemetryFile;
        }
    }
};

export default importedFileEdit;
